export enum LoanApplicationMode {
  VIEW_ONLY = 'VIEW_ONLY',
  EDIT_CONTRACT_SIGNATURE_AND_ID = 'EDIT_CONTRACT_SIGNATURE_AND_ID',
  FULL = 'FULL',
}
